<h3 mat-dialog-title style="margin-bottom:5px;">{{this.data.title}}</h3>
<mat-dialog-content class="relatedAccount">
<div *ngFor="let item of this.data.data">
    <div class="accountLabel" [ngStyle]="{'cursor':item.right==1?'pointer':'not-allowed'}" (click)="redirect(item)"><a style="text-decoration: underline;">{{item.name}}</a></div>
    <div class="entityLabel">
        <div *ngFor="let entity of item.realentitystatuses" class="entityStyle">
            <div [matTooltip]="entity.status" class="entitiesTotal" style="border-color: {{getStatusColor(entity.status)}};">{{entity.num}}</div>
            <div style="font-weight:bold">{{entity.status}}</div>
        </div>
    </div>
</div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button class="aip-button-alt" (click)="close()">Close</button>
</mat-dialog-actions>


<!-- Overlay for the dropdowns -->
<div id="selectOverlayDiv" #selectOverlay class="aip-select-overlay" style="position: absolute;"></div>